module.exports = __webpack_public_path__ + "img/files.9d15ba11.png";